export const getBrowserInfo = () => {
    const ua = navigator.userAgent;

    const isChrome =
        /Chrome/.test(ua) &&
        !/Edg/.test(ua) &&
        !/OPR/.test(ua);

    return { isChrome };
};

export const getOSInfo = () => {
    const ua = navigator.userAgent;

    const isWindows = /Windows/.test(ua);
    const isWin10Or11 = /Windows NT 10.0/.test(ua);

    const isIOS = /iPhone|iPad|iPod/.test(ua);
    const isAndroid = /Android/.test(ua);

    const isMac = /Macintosh|Mac OS X/.test(ua) && !isIOS;
    const isLinux = /Linux/.test(ua) && !isAndroid;
    const isChromeOS = /CrOS/.test(ua);

    if (isIOS || isAndroid) {
        return {
            type: "mobile"
        };
    }

    if (isWindows) {
        return {
            type: isWin10Or11
                ? "windows_supported"
                : "windows_old"
        };
    }

    if (isMac) {
        return { type: "mac" };
    }

    if (isLinux) {
        return { type: "linux" };
    }

    if (isChromeOS) {
        return { type: "chromeos" };
    }

    return { type: "unknown" };
};
